import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import HardBreak from '@tiptap/extension-hard-break'
import History from '@tiptap/extension-history'
import Placeholder from '@tiptap/extension-placeholder'
import Gapcursor from '@tiptap/extension-gapcursor'
import { ComposerEnterSubmit } from './composerEnterSubmitExtension'
import { ComposerMention } from './composerMentionExtension'

/**
 * @param {{
 *   placeholder: string,
 *   getOnEnter: () => (() => void) | undefined,
 *   enableMentions?: boolean,
 * }} opts
 */
export function buildComposerExtensions({ placeholder, getOnEnter, enableMentions = false }) {
  const base = [
    Document,
    Paragraph,
    Text,
    HardBreak,
    History,
    Gapcursor,
    Placeholder.configure({
      placeholder,
      showOnlyWhenEditable: true,
      emptyNodeClass: 'is-empty',
      emptyEditorClass: 'is-composer-editor-empty',
    }),
    ComposerEnterSubmit.configure({
      getOnEnter,
    }),
  ]

  if (enableMentions) base.push(ComposerMention)
  return base
}
